module.exports = __webpack_public_path__ + "img/cute_fictional.4169f118.svg";